module.exports = __webpack_public_path__ + "img/photo-60.f5a70ddf.webp";